export const setPasswordForm = {
    email: 'Email',
    title: {
        authentication: 'Authentication',
    },
    password: {
        label: 'Password',
        placeholder: 'Password',
    },
    confirmPassword: {
        label: 'Confirm password',
        placeholder: 'Confirm password',
    },
    assignRandomPassword: {
        label: 'Assign random password (sent to user via email)',
    },
    needToChangePassword: {
        label: 'Force change password on next login',
    },
    error: {
        confirmPasswordDoNotMatch: 'Confirm password does not match',
    },
    message: {
        success: 'Set password successfully',
    },
};
